// extracted by mini-css-extract-plugin
export default {"stickyBlueRibbon":"mWc5RVJQWE","blueRibbonSubTitle":"bBZOHMxmGO","blueRibbonTitle":"rNRzbXv4Vw","blueRibbonCta":"u74H7C8F7w","blueRibbonCloseButton":"A8ncnFSy0q"};